// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3fa5e615","147":"9fe9b391","156":"097d0179","438":"39bbd81a","706":"6b1dc5e2","726":"fb44e300"}[chunkId] + ".chunk.js";
};